var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMissingInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41971",
    "data-name": "Path 41971",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,14.745A1.177,1.177,0,0,1,7.815,13.5,1.177,1.177,0,0,1,9,12.255,1.155,1.155,0,0,1,10.185,13.5,1.166,1.166,0,0,1,9,14.745Zm.466-4.754c-.179.611-.744.622-.932,0a22.534,22.534,0,0,1-.987-5.207c0-2.333,2.918-2.344,2.918,0A23.066,23.066,0,0,1,9.466,9.991Z",
    fill: "#ffb700"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMissingInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_missing_info.10fee0aa9b37d59c02fc9b4224340167.svg";